import React from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material';
import { IconButtonV2 } from 'components/common/ui';
import CloseIcon from '@mui/icons-material/Close';

import styles from './modalV2.style';

const ModalV2 = ({
  title,
  isOpen,
  onClose,
  isLoading,
  children,
  hasCloseButton = true,
  size = 'md',
  maxWidth = 'md',
  footer = null,
  wrapperSx = {},
  titleSx = {},
  closeIconSx = {},
}) => {
  return (
    <Dialog
      size={size}
      open={isOpen}
      onClose={onClose}
      scroll="paper"
      fullWidth
      maxWidth={maxWidth}
      sx={styles.wrapper(wrapperSx)}
    >
      <DialogTitle sx={styles.title(titleSx)}>
        {title}
        {hasCloseButton && (
          <IconButtonV2
            variant="text"
            styles={styles.closeBtn}
            aria-label="close"
            onClick={onClose}
            disabled={isLoading}
          >
            <CloseIcon sx={styles.closeIcon(closeIconSx)} />
          </IconButtonV2>
        )}
      </DialogTitle>
      <DialogContent sx={styles.content}>{children}</DialogContent>
      {footer && <DialogActions sx={styles.actions}>{footer}</DialogActions>}
    </Dialog>
  );
};

export default ModalV2;
